import { render, staticRenderFns } from "./DocumentsActivities.vue?vue&type=template&id=6ef71dd3&scoped=true&"
import script from "./DocumentsActivities.vue?vue&type=script&lang=js&"
export * from "./DocumentsActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef71dd3",
  null
  
)

export default component.exports